import React, { useEffect, useState } from "react";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import moment from "moment";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";

const MarkMyAttendance = () => {
    const [punchDetails, setPunchDetails] = useState<any>(null);

    const {
        data: punchInData,
        loading: punchInLoading,
        error: punchInError,
        callApi: PunchIn
    } = useApi("/api/punch-in-shoftware", {
        method: "POST",
        autoCall: false,
    });

    const {
        data: punchOutData,
        loading: punchOutLoading,
        error: punchOutError,
        callApi: PunchOut
    } = useApi("/api/punch-out-shoftware", {
        method: "POST",
        autoCall: false,
    });

    const {
        data: punchstatusData,
        loading: punchstatusLoading,
        error: punchstatusError,
        callApi: punchstatus
    } = useApi("/api/punch-details", {
        method: "POST",
        autoCall: false,
    });

    // Fetch today's punch status
    useEffect(() => {
        fetchPunchStatus();
    }, []);

    const fetchPunchStatus = async () => {
        const payload = {
            attendance_date: moment().format("YYYY-MM-DD")
        };
        try {
            const res = await punchstatus(payload);
            if (res.success) {
                setPunchDetails(res?.data[0]);
            }
        } catch (err) {
            console.error("Failed to fetch punch status.");
        }
    };

    const handlePunchIn = async (e: any) => {
        e.preventDefault();

        // Get device coordinates (optional — can set manually or via API)
        let latitude = null;
        let longitude = null;

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    latitude = position.coords.latitude;
                    longitude = position.coords.longitude;

                    const payload = {
                        attendance_date: moment().format("YYYY-MM-DD"),
                        punchin_time_software: moment().format("HH:mm:ss"),
                        punch_in_latitude: latitude,
                        punch_in_longitude: longitude,
                    };

                    await sendPunchIn(payload);
                },
                () => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Location Disabled',
                        text: 'Please enable location to record punch coordinates.',
                    });
                }
            );
        } else {
            // if you don't want to use geolocation at all, just send null
            const payload = {
                attendance_date: moment().format("YYYY-MM-DD"),
                punchin_time_software: moment().format("HH:mm:ss"),
                punch_in_latitude: null,
                punch_in_longitude: null,
            };
            await sendPunchIn(payload);
        }
    };

    const sendPunchIn = async (payload: any) => {
        try {
            const response = await PunchIn(payload);
            if (response.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: response.message || 'Punch In successful.',
                    showConfirmButton: true,
                });
                fetchPunchStatus();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: response.message || 'Failed to punch in.',
                });
            }
        } catch (err: any) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err?.response?.message || 'Failed to punch in.',
            });
        }
    };

    const handlePunchOut = async (e: any) => {
        e.preventDefault();

        let latitude = null;
        let longitude = null;

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    latitude = position.coords.latitude;
                    longitude = position.coords.longitude;

                    const payload = {
                        attendance_date: moment().format("YYYY-MM-DD"),
                        punchout_time_software: moment().format("HH:mm:ss"),
                        punch_out_latitude: latitude,
                        punch_out_longitude: longitude,
                    };

                    await sendPunchOut(payload);
                },
                () => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Location Disabled',
                        text: 'Please enable location to record punch coordinates.',
                    });
                }
            );
        } else {
            const payload = {
                attendance_date: moment().format("YYYY-MM-DD"),
                punchout_time_software: moment().format("HH:mm:ss"),
                punch_out_latitude: null,
                punch_out_longitude: null,
            };
            await sendPunchOut(payload);
        }
    };

    const sendPunchOut = async (payload: any) => {
        try {
            const response = await PunchOut(payload);
            if (response.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: response.message || 'Punch Out successful.',
                    showConfirmButton: true,
                });
                fetchPunchStatus();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: response.message || 'Failed to punch out.',
                });
            }
        } catch (err: any) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err?.response?.message || 'Failed to punch out.',
            });
        }
    };

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
                    <div className="my-auto mb-2">
                        <h2 className="mb-2">Mark My Attendance</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to={all_routes.employeeDashboard}>
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item">Mark My Attendance</li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Attendance
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                        <div className="head-icons ms-2">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>

                <div className="card shadow-sm p-4">
                    <h4 className="mb-3">Today's Attendance</h4>
                    <table className="table table-bordered w-100">
                        <tbody>
                            <tr>
                                <th>Status</th>
                                <td>{punchDetails?.status || "Absent"}</td>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <td>{moment().format("YYYY-MM-DD")}</td>
                            </tr>
                            <tr>
                                <th>In Time</th>
                                <td>{punchDetails?.punchin_time_software || "-"}</td>
                            </tr>
                            <tr>
                                <th>Out Time</th>
                                <td>
                                    {punchDetails?.punchin_time_software && !punchDetails?.punchout_time_software
                                        ? moment().format("HH:mm:ss")
                                        : punchDetails?.punchout_time_software || "-"}
                                </td>
                            </tr>
                            <tr>
                                <th>Work Hours</th>
                                <td>{punchDetails?.hours_software || "-"}</td>
                            </tr>
                        </tbody>
                    </table>

                    {!(
                        punchDetails?.punchin_time_software &&
                        punchDetails?.punchout_time_software
                    ) && (
                        <div className="mt-4 d-flex justify-content-center">
                            {!punchDetails?.punchin_time_software && (
                                <button
                                    className="btn btn-secondary w-25"
                                    onClick={handlePunchIn}
                                >
                                    Punch In
                                </button>
                            )}
                            {punchDetails?.punchin_time_software &&
                                !punchDetails?.punchout_time_software && (
                                    <button
                                        className="btn btn-danger w-25"
                                        onClick={handlePunchOut}
                                    >
                                        Punch Out
                                    </button>
                                )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MarkMyAttendance;
